export const SET_CUSTOMERS = 'SET_CUSTOMERS'
export const SET_PICKER_OPTIONS = 'SET_PICKER_OPTIONS'
export const SET_ORG_TYPES = 'SET_ORG_TYPES'
export const SET_ORG_CLASSES = 'SET_ORG_CLASSES'
export const SET_MODE_LIST = 'SET_MODE_LIST'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js